import { render, staticRenderFns } from "./Portal3Integrator.vue?vue&type=template&id=050f6a9c&scoped=true&"
import script from "./Portal3Integrator.vue?vue&type=script&lang=js&"
export * from "./Portal3Integrator.vue?vue&type=script&lang=js&"
import style0 from "./Portal3Integrator.vue?vue&type=style&index=0&id=050f6a9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f6a9c",
  null
  
)

export default component.exports